import { NgComponent } from "@pebblepad/angular/ngComponent";
import { angularAMD } from "@pebblepad/amd";
import { ButtonClass, DialogSize, launchDialog } from "@pjs/core-ui";
import { tracker } from "@pjs/analytics";
import template from "./templates/submission-actions.html";
import "../../../react2angular/buttonComponent";
import "../../../multiLanguageService/multiLanguageService";
import "../../../share/services/shareService";
import "./styles/submission-actions.css";

class SubmissionActions extends NgComponent {
    constructor($window, multiLanguageService, shareService) {
        super();
        this.$window = $window;
        this.multiLanguageService = multiLanguageService;
        this.shareService = shareService;
        this.buttonClass = ButtonClass;
        this.goToSubmissionLink = this._goToSubmissionLink.bind(this);
        this.requestRemoval = this._requestRemoval.bind(this);
        this._setShowRemoveButton();

        this.removeButtonLabel = this.multiLanguageService.getString("sidebar.submissions.remove_submission_a11y_label", {
            workspace: this.submission.LocationName,
            assignment: this.submission.SubLocationName
        });
    }

    _setShowRemoveButton() {
        this.showRemoveButton = this.submission?.Status.toLowerCase() === "accepted" && this.submission.PreventUserFromRequestingSubmissionRemoval !== true;
    }

    _goToSubmissionLink() {
        tracker.trackEvent("Workspaces shared to", "Click", "Go to assessor view");
        this.$window.open(this.submission.LinkToSubmission, "_blank");
    }

    _removeSubmission() {
        this.shareService.removeSubmission(this.submission.Id);
        this.asset.Submissions[this.asset.Submissions.indexOf(this.submission)].Status = "removal_requested";
        this._setShowRemoveButton();
    }

    _requestRemoval() {
        const lastFocusedElement = document.activeElement;
        launchDialog({
            size: DialogSize.Medium,
            initialModel: { htmlContent: this.multiLanguageService.getString("sidebar.submissions.about_to_ask_remove_submission_message") },
            dismissAction: (_, instance) => {
                instance.close(() => {
                    if (lastFocusedElement !== null && document.body.contains(lastFocusedElement)) {
                        lastFocusedElement.focus();
                    }
                });
            },
            component: () => import("@pjs/core-ui").then((module) => module.SimpleHtmlDialogContent),
            title: this.multiLanguageService.getString("sidebar.submissions.request_removal_modal_title"),
            actions: [
                {
                    label: this.multiLanguageService.getString("buttons.cancel"),
                    ariaLabel: this.multiLanguageService.getString("buttons.cancel"),
                    buttonClass: ButtonClass.Outlined,
                    dataHook: "cancel-and-close-modal-btn",
                    disabled: () => false,
                    action: (_, instance) => {
                        instance.close(() => {
                            if (lastFocusedElement !== null && document.body.contains(lastFocusedElement)) {
                                lastFocusedElement.focus();
                            }
                        });
                    }
                },
                {
                    label: this.multiLanguageService.getString("buttons.confirm"),
                    ariaLabel: this.multiLanguageService.getString("buttons.confirm"),
                    buttonClass: ButtonClass.Contained,
                    dataHook: "confirm-and-close-modal-btn",
                    disabled: () => false,
                    action: (_, instance) => {
                        this._removeSubmission();
                        instance.close();
                    }
                }
            ]
        });
    }
}

export const submissionActionsDefinition = {
    bindings: {
        submission: "<",
        asset: "="
    },
    template: template,
    controller: SubmissionActions
};

SubmissionActions.$inject = ["$window", "multiLanguageService", "shareService"];
angularAMD.component("submissionActions", submissionActionsDefinition);
